import { CHOOSE_Q_TYPE } from './types';

function ChooseQType(event) {
  console.dir(event);
  return {
    type: CHOOSE_Q_TYPE,
    id: event.target.id,
  };
}

export default ChooseQType;



// WEBPACK FOOTER //
// ./src/actions/ChooseQuestionType.js